import { PageHero, CTABanner } from "../components/Shared";
import ClientsSection from "../sections/ClientsSection";
import { IMAGES } from "../data/site";

const ClientsPage = () => (
  <main data-testid="clients-page">
    <PageHero
      eyebrow="Our Clients"
      title="Trusted by Industry Leaders."
      description="Their continued trust reflects our commitment to reliability, consistency and quality."
      image={IMAGES.catalogue}
    />
    <ClientsSection />
    <CTABanner
      title="Join the organizations that trust us."
      text="Start with a conversation about your next print project."
    />
  </main>
);

export default ClientsPage;
